import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface OpeningHoursProps {
  hours: Record<string, { open?: string; close?: string; closed?: boolean }>;
}

const DAYS_ES = {
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo"
};

export const OpeningHours = ({ hours }: OpeningHoursProps) => {
  // Generate dummy opening hours if not provided
  const defaultHours = {
    monday: { open: "06:00", close: "22:00" },
    tuesday: { open: "06:00", close: "22:00" },
    wednesday: { open: "06:00", close: "22:00" },
    thursday: { open: "06:00", close: "22:00" },
    friday: { open: "06:00", close: "22:00" },
    saturday: { open: "08:00", close: "20:00" },
    sunday: { open: "09:00", close: "14:00" }
  };

  const displayHours = (hours && Object.keys(hours).length > 0) ? hours : defaultHours;
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-primary" />
          Horarios de Apertura
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {Object.entries(DAYS_ES).map(([dayEn, dayEs]) => {
            const dayHours = displayHours[dayEn];
            const isToday = dayEn === today;
            
            return (
              <div
                key={dayEn}
                className={`flex justify-between items-center py-2 px-3 rounded ${
                  isToday ? 'bg-primary/10 font-semibold' : ''
                }`}
              >
                <span className={isToday ? 'text-primary' : 'text-foreground'}>
                  {dayEs}
                </span>
                {dayHours?.closed ? (
                  <Badge variant="secondary">Cerrado</Badge>
                ) : (
                  <span className="text-muted-foreground">
                    {dayHours?.open} - {dayHours?.close}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
